import Script from 'next/script'

import { IS_PRODUCTION } from '@/shared/lib'

const CLARITY_PROJECT_ID = IS_PRODUCTION ? 'z0y4idec8k' : 'z0mt38takn'

/**
 * 카카오 SDK 초기화
 */
const initKakaoSDK = () => {
  if (typeof window !== 'undefined' && window.Kakao) {
    if (!window.Kakao.isInitialized()) {
      const kakaoAppKey = process.env.NEXT_PUBLIC_KAKAO_JAVASCRIPT_KEY

      if (kakaoAppKey) {
        window.Kakao.init(kakaoAppKey)
      }
    }
  }
}

/**
 * 외부 스크립트를 로드하는 컴포넌트
 */
const ThirdPartyScripts = () => {
  return (
    <>
      <Script
        src='https://onelinksmartscript.appsflyer.com/onelink-smart-script-latest.js'
        strategy='afterInteractive'
      />

      {/* 카카오 JavaScript SDK */}
      <Script
        src='https://t1.kakaocdn.net/kakao_js_sdk/2.7.9/kakao.min.js'
        integrity='sha384-JpLApTkB8lPskhVMhT+m5Ln8aHlnS0bsIexhaak0jOhAkMYedQoVghPfSpjNi9K1'
        crossOrigin='anonymous'
        strategy='afterInteractive'
        onReady={initKakaoSDK}
      />

      {/* Naver Maps SDK */}
      <Script
        type='text/javascript'
        src={`https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.NEXT_PUBLIC_NCP_API_KEY_ID}`}
        strategy='afterInteractive'
      />

      {/* Microsoft Clarity */}
      <Script id='microsoft-clarity' strategy='afterInteractive'>
        {`(function(c,l,a,r,i,t,y){
          c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
          t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
          y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
        })(window, document, "clarity", "script", "${CLARITY_PROJECT_ID}");`}
      </Script>
    </>
  )
}

export default ThirdPartyScripts
